import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { useDispatch, useSelector } from 'react-redux';
import updateState from '../actions/updateState';
import Box from '@material-ui/core/Box';
import translate from '../actions/translate';

const TransitionButtons = ({
  showBack,
  showFinal,
  disabledNext,
  disabledBack,
  executeLogic,
}) => {
  const step = useSelector((state) => state.formState.step);
  const dispatch = useDispatch();

  function handleBack() {
    dispatch(
      updateState({
        step: step - 1,
      })
    );
  }

  function handleNext() {
    if (executeLogic) {
      executeLogic();
    }
    dispatch(
      updateState({
        step: step + 1,
      })
    );
  }

  return (
    <Grid container justify="flex-end">
      {' '}
      {showBack ? (
        <Box mr={4}>
          <Button disabled={disabledBack} color="primary" onClick={handleBack}>
            {translate('Back')}
          </Button>
        </Box>
      ) : null}
      {!showFinal ? (
        <Button
          color="primary"
          variant="outlined"
          disabled={disabledNext}
          onClick={handleNext}
        >
          {translate('Next')}
        </Button>
      ) : (
        <Button onClick={handleNext} color="primary" variant="contained">
          Finish Sign Up
        </Button>
      )}
    </Grid>
  );
};

export default TransitionButtons;
